var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4652 6.69381L13.3215 4.83756C14.1074 4.12124 15.1391 3.73529 16.2022 3.7599C17.2653 3.78451 18.278 4.2178 19.03 4.96972C19.7819 5.72164 20.2152 6.73438 20.2398 7.79748C20.2644 8.86057 19.8784 9.89227 19.1621 10.6782L16.509 13.3219C16.1266 13.7057 15.6722 14.0103 15.1719 14.2181C14.6716 14.4259 14.1351 14.5328 13.5934 14.5328C13.0516 14.5328 12.5152 14.4259 12.0148 14.2181C11.5145 14.0103 11.0601 13.7057 10.6777 13.3219",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5354 17.3062L10.6792 19.1624C9.89325 19.8787 8.86155 20.2647 7.79845 20.2401C6.73536 20.2155 5.72262 19.7822 4.9707 19.0303C4.21877 18.2783 3.78549 17.2656 3.76087 16.2025C3.73626 15.1394 4.12222 14.1077 4.83854 13.3218L7.49167 10.6781C7.87403 10.2942 8.32842 9.98971 8.82875 9.78192C9.32909 9.57413 9.86552 9.46716 10.4073 9.46716C10.9491 9.46716 11.4855 9.57413 11.9858 9.78192C12.4862 9.98971 12.9405 10.2942 13.3229 10.6781",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.af1e1477cff908067e2f5c163ce01dc2.svg";
export { ForwardRef as ReactComponent };